import React, { useEffect } from "react";

export default function Size970X90({
  banner,
  title,
  description,
  titleButton,
  colorButton,
  colorTextButton,
  imageBrand,
  logoBrand,
  backgroundColorDetailsArea,
  borderRadiusButton,
}) {
  useEffect(() => {
    document.querySelector("#title").innerHTML = title;
  }, [title]);
  useEffect(() => {
    document.querySelector("#description").innerHTML = description;
  }, [description]);

  return (
    <>
      <div
        className="border border-1 d-flex flex-row"
        id="preview-banner"
        style={{
          width: `${banner.size.width}px`,
          height: `${banner.size.height}px`,
        }}
      >
        <div
          style={{
            width: `${banner.cropSize.width}px`,
            height: `${banner.cropSize.height}px`,
          }}
        >
          <img
            style={{
              width: `${banner.cropSize.width}px`,
              height: `${banner.cropSize.height}px`,
            }}
            src={
              imageBrand
                ? imageBrand
                : "/assets/img/preview-image-banner-generator.svg"
            }
          />
        </div>
        <div
          className="d-flex align-items-center justify-content-between w-100 p-2"
          style={{
            backgroundColor: backgroundColorDetailsArea,
          }}
        >
          <div className="d-flex flex-column w-100">
            <div id="title"></div>
            <div id="description"></div>
          </div>
          <div>
            <span
              className="btn btn-success px-2 py-1"
              id="view-button-in-preview-section"
              style={{
                height: "30px",
                backgroundColor: colorButton,
                borderColor: colorButton,
                borderRadius: `${borderRadiusButton}px`,
                color: colorTextButton,
              }}
            >
              {titleButton ? titleButton : "مشاهده"}
            </span>
          </div>
          {logoBrand && (
            <div className="align-self-start ">
              <img src={logoBrand} />
            </div>
          )}
        </div>
      </div>
    </>
  );
}
